import { useContext, useMemo } from 'react';
import EntityDefinitionsContext from 'contexts/EntityDefinitionsContext';
import useEntityParams from './useEntityParams';

const useSelectedEntityDefinition = () => {
  const { entityAppSlug } = useEntityParams();
  const { getEntityAndAppForSlug } = useContext(EntityDefinitionsContext);

  const entityDefinition = useMemo(() => {
    return getEntityAndAppForSlug({ slug: entityAppSlug });
  }, [entityAppSlug, getEntityAndAppForSlug]);

  return entityDefinition;
};

export default useSelectedEntityDefinition;
